import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './style.scss';
import SsoLoginForms from '../ssoLoginForms';
import { Scrollbars } from 'react-custom-scrollbars';

export default class ExternalSsoLogins extends Component {

    renderScrollbars = (child) =>
        <Scrollbars
            style={{ height: 100 }}
            hideTracksWhenNotNeeded={true}
            autoHideTimeout={1000}
            autoHideDuration={200}
        >
            {child}
        </Scrollbars>;


    generateSsoComponent(ssoAauthenticationProviders, defaultLoginMethod) {
        return ssoAauthenticationProviders.length <= 0 ?
            (<div>{this.renderScrollbars()}</div>) :
            (<div>{this.renderSortedLogin(ssoAauthenticationProviders, defaultLoginMethod)}</div>);
    };

    renderSeparator(method) {
        return <div className={classNames(styles.ssoLoginSeperator)}>
            {this.props.translationsStore.translate(method)}
        </div>
    };

    renderSortedLogin(ssoAauthenticationProviders, defaultLoginMethod) {
        let ssoLoginForms = <div>
            <SsoLoginForms authenticationProviders={ssoAauthenticationProviders}
                returnUrl={this.props.returnUrl} />
        </div>;

        return <div>
                {this.renderSeparator('SIGN_IN_USING_SSO')}
                {this.renderScrollbars(ssoLoginForms)}
            </div>;
    };

    render() {
        const ssoAauthenticationProviders = this.props.authProvidersStore.authenticationProviders.filter(authProvider => authProvider.active && authProvider.isExternal);
        const defaultLoginMethod = this.props.loginSettingsStore?.defaultLoginMethod;
        return <div> {this.generateSsoComponent(ssoAauthenticationProviders, defaultLoginMethod)} </div>;
    }
}